import { axios, BaseApiUrl } from '../axios_config';

// 查询待贴标列表
export const getLabeling = params =>{
    return axios.get(`${BaseApiUrl}/Labeling/GetLabelingByContainerNoAsync`, { params }).then(res => res.data);
}

// 查询带贴标计划明细
export const getLabelingList = params =>{
    return axios.get(`${BaseApiUrl}/Labeling/GetLabelingDetailAsyncQuery`, { params }).then(res => res.data);
}

// 查询计划装箱明细
export const getLabelingDetail = params =>{
    return axios.get(`${BaseApiUrl}/Labeling/GetLabelingDetailByshippingPlanDetailIDAsync`, { params }).then(res => res.data);
}

// 
export const addLabeling = params =>{
    return axios.post(`${BaseApiUrl}/Labeling/AddLabelingImageAsync`, { ...params }).then(res => res.data);
}

// 
export const UpdateStockingTaskBoxMarkType = params =>{
    return axios.post(`${BaseApiUrl}/Labeling/UpdateStockingTaskBoxMarkType`, [ ...params ]).then(res => res.data);
}

// 移动端查询未备柜据汇总
export const getLabelingCount = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetLabelingCountByTransportType`, { params }).then(res => res.data);
}